<template>
    <div class="main">
        <my_menu></my_menu>

        <div class="content">

            <div>
                <Tabs type="card" v-model="dep_1" @on-click="dep_click_1">
                    <TabPane :name="item.value" :label="item.label" v-for="(item, i) in dep_list" :key="i">
                        <div class="tabs_dep">
                            <Tabs v-model="dep_2" @on-click="dep_click_2">
                                <TabPane :name="dep_item.value" :label="dep_item.label"
                                    v-for="(dep_item, dep_index) in item.children" :key="dep_index"></TabPane>
                            </Tabs>
                        </div>
                    </TabPane>
                </Tabs>
            </div>

            <Spin fix v-if="table_loading"></Spin>
            <div class="query_div">
                <div>
                    <Select v-model="type_index" style="width:80px" size="small" @on-change="select_type_change">
                        <Option v-for="item in type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </div>
                <div class="query_div_2">
                  
                  
                </div>
            </div>

            <div class="table_box">
                <Table show-summary size="small" :data="table_data" :columns="columns" :height="windowHeight - 160">
                   <template #operation={row}>
                    <div>
                        <Button @click="click_jiesuan(row)" type="" size="small" style="font-size:12px"><Icon type="md-list-box" />
                        结算列表</Button>

                    </div>
                   </template>
                </Table>

            </div>

        </div>



    </div>
</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http, open_new_page,get_view_file_url } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //部门数据
            dep_list: [],
            dep_1: '',
            dep_2: '',

            //系统列表
            table_data: [],
            columns: [],

            table_loading: false,
          
            query_date: [],
            export_date: [],
            loading_export: false,

            //合计数据
            total_data: {},

            type_list: [],
            type_index: "",

        }
    },

    mounted() {
        this.window_change()

        var stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
        var stamp2 = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);

        this.query_date = [stamp1, stamp2]
        this.export_date = [stamp1, stamp2]



        // 获取部门数据
        this.get_dep_options()
        this.get_project_type()


    },

    methods: {
        click_jiesuan(row){
            var url = '/finance/kaipiao_detail?project_id='+row.project_id
            open_new_page(url)
        },

        select_type_change(e) {
            console.log(e)
            this.get_table_data()
        },

        export_ok() {
            var that = this
            var obj = {
                dep_id_list: [this.dep_1, this.dep_2],
                start_time: this.export_date[0].getTime() / 1000,
                end_time: this.export_date[1].getTime() / 1000,
                project_type: this.type_index
            }
            this.loading_export = true
            http("post", process.env.VUE_APP_HOST + "/data_panel/xiangmu/export_data", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        var url = res.data.url
                            
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.$Modal.confirm({
                            title: '提示',
                            content: '导出完成，为防止下载被拦截，请点击确认开始下载文件',
                            onOk: () => {
                                // open_new_page(url)
                                var object_name = res.data.object_name
                                get_view_file_url(object_name)
                            },
                            onCancel: () => {
                                that.$Message.info('下载已取消')
                            }
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.loading_export = false


                }
            ).catch((res) => {
                that.loading_export = false
                console.log(res, '请求出错')
            })

        },


        get_project_type() {
            var that = this
            var obj = {}

            http("post", process.env.VUE_APP_HOST + "/data_panel/jiesuan/project_type_options", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.type_list = res.data.type_list
                        that.type_index = res.data.type_list[0]['value']


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }



                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })

        },


        click_export_data() {
            this.export_data_show = true
        },



        //点击部门
        dep_click_2(e) {
            // 获取部门数据
            this.get_table_data()
        },

        dep_click_1(e) {
            this.dep_1 = e
            for (let i = 0; i < this.dep_list.length; i++) {
                var dep_id = this.dep_list[i]['value']
                if (dep_id == e) {
                    this.dep_2 = this.dep_list[i]['children'][0]['value']
                    console.log(this.dep_2)
                    this.get_table_data()

                    return
                }
            }

        },

        get_dep_options() {

            var that = this
            var obj = {

            }
            http("post", process.env.VUE_APP_HOST + "/data_panel/jiesuan/dep_options", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.dep_list = res.data.data_list
                        this.dep_1 = that.dep_list[0]['value']
                        this.dep_2 = that.dep_list[0]['children'][0]['value']

                        // 获取数据
                        that.get_table_data()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }


                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })

        },

        //时间筛选变化
        date_picker_change(e) {
            console.log(e)
            this.table_data = []
            this.get_table_data()
        },

        //获取表格数据
        get_table_data() {
            var that = this
            this.table_loading = true
            var obj = {
                // start_time: this.query_date[0].getTime() / 1000,
                // end_time: this.query_date[1].getTime() / 1000,
                dep_id: this.dep_2,
                dep_team_id: this.dep_1,
                project_type: this.type_index,
                // order_key: this.order_key,
                // order_status: this.order_status,
            }
            http("post", process.env.VUE_APP_HOST + "/data_panel/jiesuan/jiesuan_data", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.columns = res.data.columns
                        that.table_data = res.data.table_data


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    } this.table_loading = false


                }
            ).catch((res) => {
                this.table_loading = false
                console.log(res, '请求出错')
            })
        },

        click_project_name(row) {
            var url = '/workbench/project_detail?project_id=' + row.project_id + '&project_name=' + row.project_name
            open_new_page(url)
        },



        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.jiaoyan_icon {
    margin-left: 3px;
    cursor: pointer;
    ;
}

.project_name {
    cursor: pointer;
    color: #0466dd;
}

.heji_small_div {
    padding: 0 10px 0 18px;
}

.heji_small_div2 {
    font-weight: 600;
    padding: 0 10px 0 18px;
    color: red;
}

.zaizhi2 {
    font-weight: 600;
    color: red;
}

.heji_small_div3 {
    font-weight: 600;
    padding: 0 10px 0 18px;
    color: rgb(65, 163, 4);
}

.need_count {
    font-weight: 600;
    color: rgb(65, 163, 4);
}

.heiji_box {
    border-bottom: 1px solid rgb(224, 224, 224);
    background-color: #f5f7f9;
    padding: 3px 0;
    height: 26px;

}

.heji_div {
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 13px;
    color: #666;
}

.export_tag {
    padding: 2px 5px;
    font-size: 8px;
    color: rgb(255, 255, 255);
    background-color: #9bc2e7;
    border-radius: 2px;
    margin: 0 5px 3px 0
}

.export_table_txt {
    font-size: 12px;
    color: #333;
    display: flex;
    flex-wrap: wrap;
}

.export_data_field_button {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
}

.export_field {
    width: 90px;
    flex-shrink: 0;
    font-size: 13px;

}

.export_data_field {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.export_excel {
    font-size: 13px;
    cursor: pointer;
    margin-right: 10px;
    color: #0466dd;
}

.query_div_2 {
    display: flex;
    justify-content: space-between;
}

.table_box {
    padding: 0 10px;
}

.tabs_dep {
    padding: 0 10px
}

.table_box_inner {
    height: calc(100vh - 100px);
    overflow: auto;
}

.query_div {
    display: flex;
    justify-content: space-between;
    padding: 0 10px 5px 10px;
}

.table_line {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    background-color: #0466dd;
    color: #fff;
    font-size: 13px;
}

.dep_name {
    width: 120px;

}

.block_div {
    display: flex;
    margin-bottom: 3px;
    padding: 3px;

    border-bottom: 1px solid rgb(249, 248, 248);
}

.table_block {
    width: 80px;
    flex-shrink: 0
}

.table_block2 {
    width: 80px;
    color: #0466dd;
    cursor: pointer;
    flex-shrink: 0
}

.dep_box {
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-size: 13px;
    padding: 10px;
    border: 1px solid rgb(241, 241, 241);
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    width: calc(100% - 180px);
    background-color: #fff;
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100vh;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>